/* unplugin-vue-components disabled */import { render } from "./member_association.vue?vue&type=template&id=6f12347c&scoped=true"
import script from "./member_association.vue?vue&type=script&lang=js"
export * from "./member_association.vue?vue&type=script&lang=js"

import "./member_association.vue?vue&type=style&index=0&id=6f12347c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f12347c"]])

export default __exports__